import { DataService, ApiService } from "../service"

export class FavoriteService{

  /**
   * 查询是否收藏
   * @param md5 
   * @returns 
   */
  static async getModelParamsExists(md5: string, type: 'model' | 'std' = 'model') {
    return await DataService.get(`${ApiService.JrzzApi80}/user/favorite/exists?md5=${md5}&type=${type}`)
  }

  /**
   * 修改收藏数据
   * @param dataId 
   * @param data
   * @param type
   * @returns 
   */
  static async updateModelParamsExists(dataId: number, data: any, type: 'model' | 'std' = 'model') {
    return await DataService.post(`${ApiService.JrzzApi80}/user/favorite/updateParams`, {
      type,
      dataId,
      ...data,
    })
  }
  
}